import { ICoordinates } from 'libs/types/map/mapTypes';
import { coordsToArrays } from 'libs/utils/3d/3dUtils';
import { RefObject, useState } from 'react';
import { useLoadMapImages } from 'react-give-me-map';
import { Layer, MapRef, Source } from 'react-map-gl';

const MARKER_POSITION_URL =
    'https://dvtqxks0zalev.cloudfront.net/abdd691e-377d-45b1-b08e-ca6dc6953096.png';
const MARKER_POSITION_SIZE = 0.1;
const PATH_COLOR = '#000';

const nextToToilet = [
    {
        lat: 63.78819508239576,
        lng: 11.45015673171369
    },
    {
        lat: 63.78819508239576,
        lng: 11.450134695623888
    },
    {
        lat: 63.78814863218844,
        lng: 11.450134695623888
    },
    {
        lat: 63.788148632188694,
        lng: 11.45019006130056
    },
    {
        lat: 63.78819508239576,
        lng: 11.450189452978009
    },
    {
        lat: 63.78819508239576,
        lng: 11.450176839646645,
        type: 'door_start' as const
    },
    {
        lat: 63.78819508239576,
        lng: 11.45015673171369
    }
];

const underToilet = [
    {
        lat: 63.78815860866851,
        lng: 11.45023213403519
    },
    {
        lat: 63.78817466835923,
        lng: 11.45023213403519
    },
    {
        lat: 63.78817466835923,
        lng: 11.450190336754389
    },
    {
        lat: 63.788148632188694,
        lng: 11.45019006130056
    },
    {
        lat: 63.78814863218895,
        lng: 11.45023213403519
    },
    {
        lat: 63.78815057881931,
        lng: 11.45023213403519,
        type: 'door_start' as const
    },
    {
        lat: 63.78815860866851,
        lng: 11.45023213403519
    }
];

const proneoPolygon = [
    {
        lat: 63.78808683176172,
        lng: 11.450255235732897
    },
    {
        lat: 63.788131629064736,
        lng: 11.450255235732897
    },
    {
        lat: 63.78813156686721,
        lng: 11.450278872580697
    },
    {
        lat: 63.78819552227449,
        lng: 11.450278872580697
    },
    {
        lat: 63.788195807511556,
        lng: 11.45035081190855
    },
    {
        lat: 63.78827510334679,
        lng: 11.45035016612394
    },
    {
        lat: 63.78827525401849,
        lng: 11.450563313359112
    },
    {
        lat: 63.788168,
        lng: 11.450563313359112,
        type: 'door_start' as const
    },
    {
        lat: 63.788155,
        lng: 11.450563313359112
    },
    {
        lat: 63.788132274543585,
        lng: 11.450563313359112
    }
];

const sintefPolygon = [
    {
        lat: 63.78808641096299,
        lng: 11.450137148265526
    },
    {
        lat: 63.78813162906482,
        lng: 11.450137148265526
    },
    {
        lat: 63.78813162906482,
        lng: 11.450219,
        type: 'door_start' as const
    },
    {
        lat: 63.78813162906482,
        lng: 11.450239
    },
    {
        lat: 63.78813162906502,
        lng: 11.450256650805755
    }
];

const norConsultPolygon = [
    {
        lat: 63.78808641096299,
        lng: 11.449971
    },
    {
        lat: 63.78813162906482,
        lng: 11.449971
    },
    {
        lat: 63.78813162906482,
        lng: 11.450066,
        type: 'door_start' as const
    },
    {
        lat: 63.78813162906482,
        lng: 11.450086
    },
    {
        lat: 63.78813162906502,
        lng: 11.450137148265696
    }
];

const toiletPolygon = [
    {
        lat: 63.78819508239576,
        lng: 11.450189452978009
    },
    {
        lat: 63.78817451675974,
        lng: 11.450189452978009
    },
    {
        lat: 63.78817451675974,
        lng: 11.45023213403519
    },
    {
        lat: 63.78819508239576,
        lng: 11.45023213403519
    },
    {
        lat: 63.78819508239576,
        lng: 11.450226,
        type: 'door_start' as const
    },
    {
        lat: 63.78819508239576,
        lng: 11.450206
    },
    {
        lat: 63.78819508239576,
        lng: 11.450189452978009
    }
];

const sintefPath = [
    { lng: 11.450998, lat: 63.788113 },
    { lng: 11.450998, lat: 63.788162 },
    { lng: 11.450615, lat: 63.788162 },
    { lng: 11.450615, lat: 63.788288 },
    { lng: 11.450314, lat: 63.788288 },
    { lng: 11.450314, lat: 63.788209 },
    { lng: 11.450254, lat: 63.788209 },
    { lng: 11.450254, lat: 63.78814 },
    { lng: 11.450228, lat: 63.78814 },
    { lng: 11.450228, lat: 63.788131 }
];

const bathroomPath = [
    { lng: 11.450998, lat: 63.788113 },
    { lng: 11.450998, lat: 63.788162 },
    { lng: 11.450615, lat: 63.788162 },
    { lng: 11.450615, lat: 63.788288 },
    { lng: 11.450314, lat: 63.788288 },
    { lng: 11.450314, lat: 63.788209 },
    { lng: 11.450215, lat: 63.788209 },
    { lng: 11.450215, lat: 63.788195 }
];

const norconsultPath = [
    { lng: 11.450998, lat: 63.788113 },
    { lng: 11.450998, lat: 63.788162 },
    { lng: 11.450615, lat: 63.788162 },
    { lng: 11.450615, lat: 63.788288 },
    { lng: 11.450314, lat: 63.788288 },
    { lng: 11.450314, lat: 63.788209 },
    { lng: 11.450254, lat: 63.788209 },
    { lng: 11.450254, lat: 63.78814 },
    { lng: 11.450075, lat: 63.78814 },
    { lng: 11.450075, lat: 63.788131 }
];

const proneoPath = [
    {
        lat: 63.788113,
        lng: 11.450998
    },
    {
        lat: 63.788162,
        lng: 11.450998
    },
    {
        lat: 63.788162,
        lng: 11.450533
    }
];

type PolygonCoordinate = ICoordinates & { type?: 'door_start' };

//

const polygonToWalls = (coords: PolygonCoordinate[]) => {
    const res: [ICoordinates, ICoordinates, number, string][] = [];
    for (let i = 0; i < coords.length - 1; i++) {
        if (coords[i].type === 'door_start') {
            res.push([coords[i], coords[i + 1], 0.1, '#ddd']);
        } else {
            res.push([coords[i], coords[i + 1], 1, '#fff']);
        }
    }
    return res;
};

const OneWall = ({
    coords,
    width,
    color
}: {
    coords: [ICoordinates, ICoordinates];
    width: number;
    color: string;
}) => {
    const [c1, c2] = coords;
    const id = coords[0].lat + '' + coords[0].lng + '' + coords[1].lat + '' + coords[1].lng;

    const sourceId = 'wall-1|source' + id;
    const layerId = 'wall-1|layer' + id;

    const latMove = Math.abs(c2.lat - c1.lat);
    const lngMove = Math.abs(c2.lng - c1.lng);

    const latToLng = lngMove !== 0 ? latMove / (latMove + lngMove) : 1;
    const lngToLat = latMove !== 0 ? lngMove / (latMove + lngMove) : 1;

    const lngDelta = 0.000001 * width;
    const latDelta = lngDelta / 2;

    const coordNew1 = {
        lat: c1.lat - latDelta * lngToLat,
        lng: c1.lng - lngDelta * latToLng
    };
    const coordNew2 = {
        lat: c1.lat + latDelta * lngToLat,
        lng: c1.lng + lngDelta * latToLng
    };

    const coordNew3 = { lat: c2.lat + latDelta * lngToLat, lng: c2.lng + lngDelta * latToLng };
    const coordNew4 = { lat: c2.lat - latDelta * lngToLat, lng: c2.lng - lngDelta * latToLng };

    return (
        <Source
            id={sourceId}
            type="geojson"
            data={{
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        properties: {
                            level: 0,
                            name: 'nam1',
                            base_height: 0,
                            height: 1,
                            color
                        },
                        geometry: {
                            coordinates: [
                                coordsToArrays([coordNew1, coordNew2, coordNew3, coordNew4])
                            ],
                            type: 'Polygon'
                        },
                        id: sourceId
                    }
                ]
            }}
        >
            <Layer
                id={layerId}
                type="fill-extrusion"
                minzoom={18}
                source={sourceId}
                paint={{
                    'fill-extrusion-color': ['get', 'color'],
                    'fill-extrusion-height': ['get', 'height'],
                    'fill-extrusion-base': ['get', 'base_height'],
                    'fill-extrusion-opacity': 1
                }}
            />
        </Source>
    );
};

const PathToPlace = (props: { points: ICoordinates[] }) => {
    const id = 'path-to-place';
    return (
        <Source
            id={id}
            type="geojson"
            data={
                {
                    type: 'Feature',
                    geometry: {
                        type: 'MultiLineString',
                        coordinates: [coordsToArrays(props.points)]
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } as any
            }
            key={id}
        >
            <Layer
                id={id + 'line'}
                beforeId=""
                source={id}
                type="line"
                paint={{
                    'line-color': PATH_COLOR,
                    'line-width': 3,
                    'line-opacity': 0.7
                }}
                layout={{
                    'line-cap': 'round',
                    'line-join': 'round'
                }}
            />
        </Source>
    );
};

//

const Icon = (props: {
    src: string;
    coordinates: ICoordinates;
    size: number;
    minZoom: number;
    text?: string;
}) => {
    return (
        <Source
            type="geojson"
            data={{
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [props.coordinates.lng, props.coordinates.lat]
                        },
                        properties: {}
                    }
                ]
            }}
        >
            <Layer
                minzoom={props.minZoom}
                id={props.src + props.coordinates.lat + '' + props.coordinates.lng}
                type="symbol"
                layout={{
                    'icon-size': props.size,
                    'icon-image': props.src,
                    'icon-allow-overlap': true,
                    'text-field': props.text ?? '',
                    'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                    'text-offset': [0, 1.0],
                    'text-size': 14,
                    'text-anchor': 'top',
                    'text-allow-overlap': false,
                    'text-optional': true
                }}
            />
        </Source>
    );
};

const Text = (props: {
    text: string;
    coordinates: ICoordinates;
    minZoom?: number;
    maxZoom?: number;
    type: 'room-label' | 'building-label';
    color: string;
}) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSize = (): any => {
        if (props.type === 'room-label') {
            return ['interpolate', ['exponential', 2], ['zoom'], 16, 10, 20, 20];
        }
        if (props.type === 'building-label') {
            return ['interpolate', ['exponential', 2], ['zoom'], 16, 14, 20, 25];
        }
        return 14;
    };

    return (
        <Source
            type="geojson"
            data={{
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [props.coordinates.lng, props.coordinates.lat]
                        },
                        properties: {}
                    }
                ]
            }}
        >
            <Layer
                minzoom={props.minZoom ?? 1}
                maxzoom={props.maxZoom ?? 24}
                id={props.text + props.coordinates.lat + '' + props.coordinates.lng}
                type="symbol"
                layout={{
                    'icon-allow-overlap': true,
                    'text-field': props.text,
                    'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                    'text-size': getSize(),
                    'text-anchor': 'center',
                    'text-allow-overlap': false
                }}
                paint={{
                    'text-color': props.color
                }}
            />
        </Source>
    );
};

export type PossiblePaths = 'proneo' | 'sintef' | 'norconsult' | 'toilet1';

export const IndoorMapTest = (props: {
    mapRef: RefObject<MapRef>;
    selectedPath?: PossiblePaths;
}) => {
    const [areImagesLoaded, setAreImagesLoaded] = useState(false);

    useLoadMapImages({
        mapRef: props.mapRef,
        imageUrls: [
            MARKER_POSITION_URL,
            'https://dvtqxks0zalev.cloudfront.net/ed5d481f-9829-4ff0-b879-133d8880d02e.png',
            'https://dvtqxks0zalev.cloudfront.net/42856802-9bef-4813-8bf6-b3a3a798470b.png'
        ],
        onLoad: () => {
            setAreImagesLoaded(true);
        }
    });

    if (!areImagesLoaded) {
        return null;
    }

    const walls = [
        ...polygonToWalls(toiletPolygon),
        ...polygonToWalls(proneoPolygon),
        ...polygonToWalls(sintefPolygon),
        ...polygonToWalls(norConsultPolygon),
        ...polygonToWalls(underToilet),
        ...polygonToWalls(nextToToilet)
    ];

    const selectedPath = (() => {
        switch (props.selectedPath) {
            case 'norconsult':
                return norconsultPath;
            case 'proneo':
                return proneoPath;
            case 'sintef':
                return sintefPath;
            case 'toilet1':
                return bathroomPath;
            default:
                return null;
        }
    })();

    return (
        <>
            {walls.map((coords) => (
                <OneWall
                    key={
                        coords[0].lat + '' + coords[0].lng + '' + coords[1].lat + '' + coords[1].lng
                    }
                    coords={[coords[0], coords[1]]}
                    width={coords[2]}
                    color={coords[3]}
                />
            ))}
            {selectedPath && <PathToPlace points={selectedPath} />}
            <Icon
                src={MARKER_POSITION_URL}
                coordinates={{ lng: 11.450997, lat: 63.788107 }}
                size={MARKER_POSITION_SIZE}
                minZoom={17}
            />
            <Text
                coordinates={{ lng: 11.45045, lat: 63.788181 }}
                minZoom={18}
                text={'Proneo'}
                type="room-label"
                color="#fff"
            />
            <Text
                coordinates={{ lng: 11.450201, lat: 63.788111 }}
                minZoom={18}
                text={'Sintef'}
                type="room-label"
                color="#fff"
            />
            <Text
                coordinates={{ lng: 11.450051, lat: 63.788111 }}
                minZoom={18}
                text={'Norconsult'}
                type="room-label"
                color="#fff"
            />
            <Text
                coordinates={{ lng: 11.450527, lat: 63.78826 }}
                maxZoom={18}
                text={'VIP Senteret'}
                type="building-label"
                color="#000"
            />
        </>
    );
};
